import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import Overview from "./Detail/Overview/Index";
import Plan from "./Detail/Plan/Index";
import StaffList from "./Detail/Staff";
import TimeWorkingList from "./Detail/TimeWorking";
import ConnectingList from "./Detail/Connecting";
import ReviewList from "./Detail/Review";
import Menu from "./Detail/Menu";
import UtilitiesList from "./Detail/Utilities";
import BarTable from "./Detail/BarTable";

const LIST_TYPE = [
  { label: "Overview", value: "Overview" },
  // { label: "Plan", value: "Plan" },
  // { label: "Connecting", value: "Connecting" },
  { label: "Time Working", value: "TimeWorking" },
  { label: "Tables", value: "BarTable" },
  // { label: "Booking Hour", value: "Booking Hour" },
  { label: "Utilities", value: "Utilities" },
  { label: "Menu", value: "Menu" },
  { label: "Bartenders", value: "Staff" },
  { label: "Rating & Review", value: "Rating & Review" },
];

interface BarListDetailProps {
  barID: string;
  setLinkImage: any;
  tabDetailActive?: string;
  setTitleBarDetail?: any;
}

const BarListDetail = ({
  barID,
  setLinkImage,
  tabDetailActive,
  setTitleBarDetail
}: BarListDetailProps) => {
  const { t } = useTranslation();
  const [typeTab, setTypeTab] = useState<string>("Overview");

  const handleChangeTab = (name: string) => {
    setTypeTab(name);
  };

  useEffect(() => {
    if(tabDetailActive) {
      setTypeTab(tabDetailActive);
    }
  }, [tabDetailActive])

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}>
            <div
              style={{
                background: "#f3f6f9",
                borderTopLeftRadius: "0.6rem",
                borderTopRightRadius: "0.6rem",
                position: "sticky",
                top: "-20px",
                zIndex: 99,
              }}
            >
              <div
                className="d-block"
                style={{
                  background: "#f3f6f9",
                  borderRadius: "0.6rem",
                  width: "fit-content",
                }}
              >
                <Nav tabs className="nav nav-tabs nav-justified">
                  {LIST_TYPE?.map((item) => (
                    <li className="list-inline-item" key={item?.value}>
                      <NavItem>
                        <NavLink
                          style={{
                            cursor: "pointer",
                            background: `${
                              String(typeTab) === String(item?.value)
                                ? "#009ef7"
                                : "unset"
                            }`,
                            color: `${
                              String(typeTab) === String(item?.value)
                                ? "white"
                                : "#009ef7"
                            }`,
                            borderWidth: 0,
                          }}
                          className={
                            String(typeTab) === String(item?.value)
                              ? "bar-detail active"
                              : "bar-detail"
                          }
                          onClick={() => handleChangeTab(item?.value)}
                        >
                          {t(item?.label)}
                        </NavLink>
                      </NavItem>
                    </li>
                  ))}
                </Nav>
              </div>
            </div>

            <TabContent activeTab={typeTab}>
              <TabPane tabId={typeTab} className="position-relative">
                {typeTab === "Overview" && (
                  <Overview
                    barId={barID}
                    setLinkImage={setLinkImage}
                    setTitleBarDetail={setTitleBarDetail}
                  />
                )}
                {typeTab === "Plan" && <Plan />}
                {typeTab === "Utilities" && <UtilitiesList barID={barID} />}
                {typeTab === "Staff" && <StaffList barID={barID} />}
                {typeTab === "TimeWorking" && (
                  <TimeWorkingList barID={barID} />
                )}
                {typeTab === "BarTable" && <BarTable barID={barID} />}
                {typeTab === "Connecting" && <ConnectingList />}
                {typeTab === "Rating & Review" && (
                  <ReviewList 
                    barID={barID}
                    setLinkImage={setLinkImage}
                  />
                )}
                {typeTab === "Menu" && <Menu barID={barID} />}
              </TabPane>
            </TabContent>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BarListDetail;
